/**
 * usePrelaunchConfig — fetch /api/prelaunch/config exactly once at app boot.
 *
 * Returns { loading, enabled, config }. Cached in module scope so
 * route-changes don't refetch.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _inflight = null;

export function usePrelaunchConfig() {
  const [state, setState] = useState({
    loading: !_cache,
    enabled: _cache?.prelaunch_portal_enabled || false,
    config: _cache || null,
    error: null,
  });

  useEffect(() => {
    if (_cache) return;
    if (!_inflight) {
      _inflight = axios.get(`${API}/prelaunch/config`).then((r) => r.data).catch((err) => {
        // Fail-closed: if config can't load, default to NOT showing the portal
        // so the real site stays accessible even during transient outages.
        return { prelaunch_portal_enabled: false, compounds: [], buyer_types: [], timelines: [], contact_methods: [] };
      });
    }
    _inflight.then((data) => {
      _cache = data;
      setState({ loading: false, enabled: !!data.prelaunch_portal_enabled, config: data, error: null });
    });
  }, []);

  return state;
}
